import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material/styles';
import DashboardNavbar from './DashboardNavbar';
import {
  Grid,
  Column,
  Content,
  Theme,
  GlobalTheme
} from '@carbon/react';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';
// import { useTranslation } from 'react-i18next';

// const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
//   backgroundColor: theme.palette.background.default,
//   display: 'flex',
//   height: '100%',
//   overflow: 'hidden',
//   width: '100%'
// }));

// const DashboardLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
//   display: 'flex',
//   flex: '1 1 auto',
//   overflow: 'hidden',
//   paddingTop: '64px',
//   [theme.breakpoints.up('lg')]: {
//     paddingLeft: '0px'
//   }
// }));

// const DashboardLayoutContainer = experimentalStyled('div')({
//   display: 'flex',
//   flex: '1 1 auto',
//   overflow: 'hidden'
// });

// const DashboardLayoutContent = experimentalStyled('div')({
//   flex: '1 1 auto',
//   height: '100%',
//   overflow: 'auto',
//   position: 'relative',
//   WebkitOverflowScrolling: 'touch'
// });

const DashboardLayout = () => {
  // const [setIsSidebarMobileOpen] = useState(false);
  // const { t } = useTranslation();
  const { configSiteData: {tm} } = useAuth();

  return (

    // <DashboardLayoutRoot>
    //   <DashboardNavbar />
    //   {/* <DashboardSidebar */}
    //   {/*  onMobileClose={() => setIsSidebarMobileOpen(false)} */}
    //   {/*  openMobile={isSidebarMobileOpen} */}
    //   {/* /> */}
    //   <DashboardLayoutWrapper>
    //     <DashboardLayoutContainer>
    //       <DashboardLayoutContent>
    //         <Outlet />
    //       </DashboardLayoutContent>
    //     </DashboardLayoutContainer>
    //   </DashboardLayoutWrapper>
    // </DashboardLayoutRoot>

    <>
      <Theme theme="g100">
        <DashboardNavbar />
      </Theme>
      <Content>
        <Outlet />
        <div style={{
          justifySelf: 'center',
          marginTop: 'auto',
          paddingBottom: '2rem'
        }}>
          <span className='terms-of-service-text'>
            {tm.Footer}{' '}
            <a
              className='terms-of-service-text'
              href="https://docs.rpcfast.com/legal/terms-of-service"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
          </span>
        </div>
      </Content>
      {/* <DashboardSidebar */}
      {/*  onMobileClose={() => setIsSidebarMobileOpen(false)} */}
      {/*  openMobile={isSidebarMobileOpen} */}
      {/* /> */}
    </>
  );
};

export default DashboardLayout;
